var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCliente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.738,
    height: 15.737,
    viewBox: "0 0 15.738 15.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cliente_1_",
    "data-name": "cliente (1)",
    transform: "translate(0 -0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3049",
    "data-name": "Grupo 3049",
    transform: "translate(0 7.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3048",
    "data-name": "Grupo 3048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2249",
    "data-name": "Caminho 2249",
    d: "M15.246,236.47a1.383,1.383,0,0,0-1.9.115l-1.355,1.455a1.386,1.386,0,0,0-1.321-.973H8.247c-.184,0-.245-.07-.564-.316a3.234,3.234,0,0,0-4.252.01l-.889.783a1.377,1.377,0,0,0-1.268-.016l-1.02.51a.461.461,0,0,0-.206.619l2.766,5.533a.461.461,0,0,0,.619.206l1.02-.51a1.382,1.382,0,0,0,.764-1.286h5.448a3.243,3.243,0,0,0,2.582-1.291l2.213-2.951A1.379,1.379,0,0,0,15.246,236.47Zm-11.205,6.59-.607.3L1.08,238.656l.607-.3a.461.461,0,0,1,.618.206l1.942,3.883A.461.461,0,0,1,4.041,243.061ZM14.723,237.8l-2.213,2.951a2.316,2.316,0,0,1-1.844.922H4.9l-1.728-3.456.873-.768a2.311,2.311,0,0,1,3.046,0,1.632,1.632,0,0,0,1.161.535h2.418a.461.461,0,1,1,0,.922H8.311a.461.461,0,0,0,0,.922h2.664a1.387,1.387,0,0,0,1.012-.44l2.03-2.179a.461.461,0,0,1,.707.59Z",
    transform: "translate(0 -235.959)",
    fill: "#64c2c8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3051",
    "data-name": "Grupo 3051",
    transform: "translate(5.563 0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3050",
    "data-name": "Grupo 3050",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2250",
    "data-name": "Caminho 2250",
    d: "M185.125,3.159a1.837,1.837,0,0,0,.51-1.271A1.869,1.869,0,0,0,183.791.013a1.9,1.9,0,0,0-1.875,1.875,1.81,1.81,0,0,0,.527,1.275,2.813,2.813,0,0,0-1.449,2.444v.461a.461.461,0,0,0,.461.461H186.1a.461.461,0,0,0,.461-.461V5.607A2.81,2.81,0,0,0,185.125,3.159ZM183.791.935a.951.951,0,0,1,.922.953.923.923,0,0,1-.922.922.951.951,0,0,1-.953-.922A.978.978,0,0,1,183.791.935Zm-1.875,4.672a1.9,1.9,0,0,1,1.875-1.875,1.862,1.862,0,0,1,1.844,1.875Z",
    transform: "translate(-180.994 -0.013)",
    fill: "#64c2c8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliente);
export default __webpack_public_path__ + "static/media/cliente.f1e71c03c695b965c6308b606fdfdac1.svg";
export { ForwardRef as ReactComponent };